var selectors = {
  buttons: {},
  containers: {
    cartDrawer: '#CartDrawer',
    cartOverlay: '.cart-drawer-overlay'
  },
  icons: {
    cartHeader: '.icon-cart',
    closeCart: '.close-cart'
  },
  buttons: {
    checkout: '#CartDrawer button#checkout'
  }
};

var CartDrawer = (function($) {
  var $cartDrawer = $(selectors.containers.cartDrawer);
  var $cartForm = $cartDrawer.find('form');
  var cartDrawerActiveClass = 'show-cart-drawer';
  var cartUpdating = 'cart-updating';
  
  var methods = {
    toggle: function() {
      document.body.classList.toggle(cartDrawerActiveClass);        
    },
    open: function() {
      document.body.classList.add(cartDrawerActiveClass);
      $cartDrawer.scrollTop(0);
    },
    close: function() {
      document.body.classList.remove(cartDrawerActiveClass);
      document.body.classList.remove('blocked-scroll');
      $('.cart_container').removeClass('active_link');
    },
    refresh: function() {
      return new Promise(function(resolve, reject) {
        document.body.classList.add(cartUpdating);

        $.get('/cart?view=raw-drawer', function(response) {
          var $newCartDrawer = $(response).find('#CartDrawer');
          $cartDrawer.html($newCartDrawer.html());

          $(document).trigger({type: 'cart-updated'});          

          // Remove cart item quantity events
          $('body').off("change", "#cart_form input.quantity");
          document.body.classList.remove(cartUpdating);
          resolve($cartDrawer);
          
          if(typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") {
            mlvedaload();
          }
        });
      });
    },
    updateItem: function(updates) {
      return new Promise(function(resolve, reject) {
        $.post('/cart/update.js', {
          updates: updates
        }, null, 'json')
        .done(function(data) {
          $(document).trigger({type: 'cart-updated'});          
          resolve(data);
        });
      });
    },
    updatePrices: function() {
      return new Promise(function(resolve, reject) {
        document.body.classList.add(cartUpdating);
         $.get('/cart?view=raw-drawer', function(response) {
          var SubtotalPrice = $(response).find('.cart_subtotal .was_price').text();
          $cartDrawer.find('.cart_subtotal .was_price').html(SubtotalPrice);
        });
        var money_format = $('body').data('money-format');
        $.getJSON('/cart.js', function(cart) {
          // Individual items pricing - Use if required
          /*
          cart.items.forEach(function(item) {
            var $itemPrice = $('[data-item-id="'+ item.id +'"] .money');
            $itemPrice.html(Shopify.formatMoney(item.price, money_format));
          });
          */
          
          // Subtotal
          var $total = $('#CartDrawer .cart_subtotal .actual-money');
          $total.html(Shopify.formatMoney(cart.total_price, money_format));
          document.body.classList.remove(cartUpdating);
          resolve($cartDrawer);
        });
      });
    },
    getCartData: function() {
      return new Promise(function(resolve, reject) {
        $.getJSON('/cart.js', function(cart) {
          resolve(cart);
        });        
      });      
    },
    checkIfCartHasSubscription: function(cart) {
      var cartHasSubscription = false;
      const isSubscriptions = document.querySelectorAll('[data-is-subscription]');
      const anySubs = [...isSubscriptions].map(isSubscription => parseInt(isSubscription.dataset.isSubscription))
      if(anySubs.includes(1)){
        cartHasSubscription = true;
      }
      return cartHasSubscription;
    },
    checkout: function() {
      debugger;
      $cartForm.submit();
    },
    swapProducts: async(remove, add) => {
      const isCartTemplate = $('#shopify-section-cart-template').length > 0;

      $cartDrawer.addClass('disabled');
      await CartDrawer.updateItem(remove);
      await $.post('/cart/add.js', add);
      if (isCartTemplate){
        location.reload();
      } else {
        await CartDrawer.refresh();
      }
      $cartDrawer.removeClass('disabled');
    }
  };

  return methods;
})(jQuery);

(function($) {  
  $(function() {
    CartDrawer.refresh();
    
    $(document).on('click', selectors.icons.cartHeader, function(e) {
      e.preventDefault();
      CartDrawer.toggle();
    });    
    
    $(document).on('click', [selectors.icons.closeCart, selectors.containers.cartOverlay].join(','), function(e) {
      CartDrawer.close();
    });
    
    // Ajax Add To cart
    $('body').on('submit', ".product_form form, .shopify-product-form", function(e) {
      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
        },
        success: function(itemData) {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
            CartDrawer.refresh().then(CartDrawer.open);
          }, 500);
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
    });
    
    // On Quantity update
    $('body').on("change", "#CartDrawer #cart_form input.quantity", function(e) {
      e.preventDefault();
      var $qty = $(this);
      var qty = parseInt($qty.val());
      var variantId = $qty.attr('id').split('_')[1];
      var itemUpdates = {};
      itemUpdates[variantId] = qty;
      
      var itemRemoved = qty == 0;
      if (itemRemoved) {
        CartDrawer.updateItem(itemUpdates).then(CartDrawer.refresh);
      }
      else {
        CartDrawer.updateItem(itemUpdates).then(CartDrawer.refresh);
      }
    });
    
    // on cart update, check buttons
    $(document).on('cart-updated', function(e) {
      setTimeout(function() {
        CartDrawer.getCartData().then(function(cart) {
          $('.cart_count').text(cart.item_count);
          var cart_subscription_items = cart.items.filter(function(item) {
            return item.properties && item.properties.hasOwnProperty('subscription_id');
          });

          var cart_has_subscriptions = cart_subscription_items.length !== 0;
          $('#CartDrawer').toggleClass('has-subscriptions', cart_has_subscriptions);
        });
      }, 1000);
    });

  });
})(jQuery);